// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__QqWvV","box":"WorkspacesBox_box__hBylN","node":"WorkspacesBox_node__1r4HA"};